module.exports = __webpack_public_path__ + "ath_game_web/img/4.2.361c6cc8.png";